/**
 * Verified 4-3-3 card origins in the 570×694 Figma field coordinate space.
 * Source: xE5Jd227ZgDwnFzRDJzxWG, Scenario 255:7101 / Watchlist 281:2912.
 * Other formations retain their existing row layout until individually verified.
 */
import { TacticalSlot } from "@/generated/graphql";

export const PITCH_433_ANCHORS = [
  { slot: TacticalSlot.Lw, x: 20.8, y: 150 },
  { slot: TacticalSlot.St, x: 226, y: 100 },
  { slot: TacticalSlot.Rw, x: 431.2, y: 150 },
  { slot: TacticalSlot.Lcm, x: 83.5, y: 330 },
  { slot: TacticalSlot.Cm, x: 226, y: 350 },
  { slot: TacticalSlot.Rcm, x: 368.5, y: 330 },
  { slot: TacticalSlot.Lb, x: 9.4, y: 440 },
  { slot: TacticalSlot.Lcb, x: 151.9, y: 464 },
  { slot: TacticalSlot.Rcb, x: 300.1, y: 464 },
  { slot: TacticalSlot.Rb, x: 442.6, y: 450 },
  { slot: TacticalSlot.Gk, x: 226, y: 584 },
] as const;
